import { Link, useLocation } from "react-router-dom";
import { Sparkles } from "lucide-react";

export default function Header() {
  const loc = useLocation();
  const onLanding = loc.pathname === "/";

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-40 backdrop-blur-md bg-white/70 border-b border-zinc-200/70 no-print"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        <Link to="/" data-testid="brand-link" className="flex items-center gap-2">
          <div className="h-8 w-8 rounded-lg bg-indigo-600 flex items-center justify-center">
            <Sparkles className="h-4 w-4 text-white" />
          </div>
          <span className="font-display font-black text-lg tracking-tight text-zinc-900">
            LeadGen<span className="text-indigo-600">.</span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-8 text-sm text-zinc-600">
          <a href="/#how" data-testid="nav-how" className="hover:text-zinc-900">How it works</a>
          <a href="/#pricing" data-testid="nav-pricing" className="hover:text-zinc-900">Pricing</a>
          <Link to="/plans" data-testid="nav-my-plans" className="hover:text-zinc-900">My plans</Link>
        </nav>

        <Link
          to="/generate"
          data-testid="header-cta-btn"
          className="btn-lift inline-flex items-center gap-2 rounded-full bg-zinc-900 hover:bg-indigo-600 text-white px-4 h-10 text-sm font-medium"
        >
          {onLanding ? "Get my next moves" : "New plan"}
        </Link>
      </div>
    </header>
  );
}
